import { useLiveStreamAppContext } from "../ContextStore/Store";
import { memo, useState } from "react";
import Avtar from "./Avtar";
import { getDeviceInfoDetails } from "../utils/PlatformCheck";
import { AmplitudeAddLog } from "../utils/AppAmplitude";
import ClassAppointmentExitPopup from "../PopupModal/EndCallModal";
import { getBrowserPermissionSteps } from "../utils/getBrowserPermissionSteps";

function MobileViewDetail(props) {
  const {
    classesName,
    userNameHost,
    isMic,
    toggleGearMobile,
    isCam,
    photoHostUrl,
    role,
    __userId,
    __merchantId,
    appInsightTrack,
    businessURL,
    grp,
    __appConfirmUniqueID,
    cameraPermission,
    microphonePermission
  } = useLiveStreamAppContext();

  const deviceInfoDetails = getDeviceInfoDetails();
  const [isCameraEnabled, setIsCameraEnabled] = useState(false);
  const [isMicrophoneEnabled, setIsMicrophoneEnabled] = useState(false);

  const cancelCall = () => {
    AmplitudeAddLog(
      __userId,
      __merchantId,
      businessURL,
      115,
      grp,
      __appConfirmUniqueID
    );
    setTimeout(() => {
      if (deviceInfoDetails.isMobileApp && !deviceInfoDetails.isAndroid) {
        try {
          window.close();
        } catch (e) {
          appInsightTrack(
            __merchantId,
            __userId,
            "Mobile device Dismiss",
            "",
            e
          );
        }
        window.location.href =
          role === "Presenter"
            ? "closewindowpro://closewindowProURL"
            : "closewindow://closewindowURL";
      } else {
        window.close();
      }
    }, 1500);
  };

  return (
    <>
      <div className="user-avatar-box">
        <div>
          <a href className="close-icon" onClick={cancelCall}>
            <i
              className="fa-solid fa-xmark font-awesome-solid-pro"
              aria-hidden="true"
            ></i>
          </a>
        </div>
        <div className="avatar-size avatar-size-80">
          <Avtar photoUrl={photoHostUrl} userName={userNameHost} />
        </div>
        <div className="attendee-head-name">{classesName}</div>
        <div className="host-name">{userNameHost}</div>
        <div className="block-controls host-Setting">
          <div className="controls-btn" onClick={() => toggleGearMobile()}>
            <i
              className={"icon font-awesome-light-pro va-cog"}
              aria-hidden="true"
            ></i>
          </div>
          <div
            className="controls-btn controls-btn-relative"
            onClick={() => {
              if (microphonePermission === "granted") {
                props.toggleLocalAudio();
              } else if (microphonePermission !== "granted") {
                setIsMicrophoneEnabled(true);
              }
            }} // Use the function from props
          >
            <i
              className={`icon fas font-awesome-solid-pro va-microphone ShowHideSoundIcon ${microphonePermission !== "granted" && "divDisabled va-microphone-slash"} ${!isMic && "va-microphone-slash"}`} aria-hidden="true"
            >
            </i>
            {microphonePermission !== "granted" && (
              <i
                className="icon-warning-bell icon font-awesome-solid-pro va-exclamation-triangle mb-icon"
                style={{ color: "orange", marginTop: "8px" }}
                title="Camera and microphone are disabled"
              />
            )}
          </div>
          <div
            className="controls-btn controls-btn-relative"
            onClick={() => {
              if (cameraPermission === "granted") {
                props.toggleLocalVideo();
              } else if (cameraPermission !== "granted") {
                setIsCameraEnabled(true);
              }
            }}
          >
            <i
              className={`icon fas font-awesome-solid-pro va-video ShowHideVideoIcon ${!isCam && "va-video-slash"
                }  ${cameraPermission !== "granted" && "divDisabled va-video-slash"
                }`}
              aria-hidden="true"
            ></i>
            {cameraPermission !== "granted" && (
              <i
                className=" icon-warning-bell icon font-awesome-solid-pro va-exclamation-triangle mb-icon"
                style={{ color: "orange", marginTop: "8px" }}
                title="Camera and microphone are disabled"
              />
            )}
          </div>
        </div>
      </div >
        {isMicrophoneEnabled && (
              <ClassAppointmentExitPopup
                show={isMicrophoneEnabled}
                onHide={() => setIsMicrophoneEnabled(false)}
                message={getBrowserPermissionSteps("microphone")}
                buttontext={"Open Browser Settings"}
                headtext={"Allow Vagaro to Access Microphone"}
              />
            )}
            {isCameraEnabled && (
              <ClassAppointmentExitPopup
                show={isCameraEnabled}
                onHide={() => setIsCameraEnabled(false)}
                message={getBrowserPermissionSteps("camera")}
                buttontext={"Open Browser Settings "}
                headtext={"Allow Vagaro to Access Camera"}
              />
            )}
    </>
  );
}
export default memo(MobileViewDetail);
